import { useState } from "react";
import { GiBodyHeight } from "react-icons/gi";
import SectionHeading from "../common/SectionHeading";
import { calculateBMI, bmiCategory } from "../../utils/validators";
import "./BMICalculator.css";

export default function BMICalculator() {
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!height || !weight) {
      setError("Please enter both your height and weight.");
      setResult(null);
      return;
    }
    if (Number(height) <= 0 || Number(weight) <= 0) {
      setError("Height and weight must be greater than zero.");
      setResult(null);
      return;
    }
    const bmi = calculateBMI(height, weight);
    if (bmi === null) {
      setError("Please enter valid numeric values.");
      setResult(null);
      return;
    }
    setError("");
    setResult(bmi);
  };

  const category = result != null ? bmiCategory(result) : null;
  const clampedPercent = result != null ? Math.min(100, Math.max(0, ((result - 15) / (35 - 15)) * 100)) : 0;

  return (
    <section className="bmi-section section">
      <div className="container bmi-section__grid">
        <div>
          <SectionHeading
            eyebrow="Know Your Numbers"
            title="Quick"
            highlight="BMI Calculator"
            description="A quick, general indicator — not a diagnosis. Talk to your trainer or a doctor for a full health assessment."
          />
          <form className="bmi-form" onSubmit={handleSubmit} noValidate>
            <div className="bmi-form__field">
              <label htmlFor="bmi-height">Height (cm)</label>
              <input
                id="bmi-height"
                type="number"
                inputMode="decimal"
                min="0"
                placeholder="e.g. 170"
                value={height}
                onChange={(e) => setHeight(e.target.value)}
              />
            </div>
            <div className="bmi-form__field">
              <label htmlFor="bmi-weight">Weight (kg)</label>
              <input
                id="bmi-weight"
                type="number"
                inputMode="decimal"
                min="0"
                placeholder="e.g. 68"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
              />
            </div>
            {error && <p className="bmi-form__error" role="alert">{error}</p>}
            <button type="submit" className="btn btn-primary">Calculate BMI</button>
          </form>
        </div>

        <div className="bmi-result">
          <GiBodyHeight className="bmi-result__icon" aria-hidden="true" />
          {result == null ? (
            <p className="bmi-result__placeholder">Your result will appear here.</p>
          ) : (
            <>
              <p className="bmi-result__value">{result}</p>
              <p className={`bmi-result__category bmi-result__category--${category.tone}`}>{category.label}</p>
              <div className="bmi-result__bar">
                <div className="bmi-result__bar-fill" style={{ width: `${clampedPercent}%` }} />
              </div>
              <p className="bmi-result__disclaimer">
                BMI is a general screening tool and does not account for muscle mass, age or body composition.
                This is informational only and not medical advice.
              </p>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
